var map = {
	"./ABT.jpg": "./src/resources/img/bene/ABT.jpg",
	"./AIS.jpg": "./src/resources/img/bene/AIS.jpg",
	"./BCI.jpg": "./src/resources/img/bene/BCI.jpg",
	"./BCP.jpg": "./src/resources/img/bene/BCP.jpg",
	"./BRIDGE.jpg": "./src/resources/img/bene/BRIDGE.jpg",
	"./CTL.jpg": "./src/resources/img/bene/CTL.jpg",
	"./DBP.jpg": "./src/resources/img/bene/DBP.jpg",
	"./MEA.jpg": "./src/resources/img/bene/MEA.jpg",
	"./NBTC.jpg": "./src/resources/img/bene/NBTC.jpg",
	"./NHSO.jpg": "./src/resources/img/bene/NHSO.jpg",
	"./PEA.jpg": "./src/resources/img/bene/PEA.jpg",
	"./PTTGC.jpg": "./src/resources/img/bene/PTTGC.jpg",
	"./SCCC.jpg": "./src/resources/img/bene/SCCC.jpg",
	"./SCG.jpg": "./src/resources/img/bene/SCG.jpg",
	"./SHELL.jpg": "./src/resources/img/bene/SHELL.jpg",
	"./TIS.jpg": "./src/resources/img/bene/TIS.jpg",
	"./TLT.jpg": "./src/resources/img/bene/TLT.jpg",
	"./TOP.jpg": "./src/resources/img/bene/TOP.jpg",
	"./VNT.jpg": "./src/resources/img/bene/VNT.jpg",
	"./null.jpg": "./src/resources/img/bene/null.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/resources/img/bene sync recursive ^\\.\\/.*\\.jpg$";